import { FC, useEffect } from 'react';
import Lottie from 'lottie-web';

interface AnimationProps {
  animation: any;
  loop?: boolean;
}

const Animation: FC<AnimationProps> = ({
  animation,
  loop = true,
}) => {
  useEffect(() => {
    const lottieInstance = Lottie.loadAnimation({
      container: document.getElementById('lottie') as HTMLElement,
      autoplay: true,
      loop,
      renderer: 'svg',
      animationData: animation,
    });
    lottieInstance.setSpeed(0.8);

    return () => {
      lottieInstance.destroy();
    };
  }, []);

  return (
    <div id="lottie" />
  );
};

export default Animation;
